import { securedAxios } from "../lib/axios";
import { unmaskCNPJ, unmaskCEP } from "../lib/masks";

export default {
  namespaced: true,
  state: {
    empresas: [],
  },
  mutations: {
    carregar(state, empresas) {
      state.empresas = [];
      state.empresas = empresas;
    },
    remover(state, id) {
      state.empresas = state.empresas.filter((p) => p.id !== id);
    },
  },
  actions: {
    async listar({ commit }) {
      try {
        const response = await securedAxios.get(`/empresas`);
        commit("carregar", response.data);
        return Promise.resolve(response);
      } catch (e) {
        return Promise.reject(e);
      }
    },
    carregar(context, id_empresa) {
      return securedAxios.get(`/empresas/${id_empresa}`);
    },
    async gravar(context, empresa) {
      try {
        let response;
        const dados = {
          ...empresa,
          cnpj: unmaskCNPJ(empresa.cnpj),
          cep: unmaskCEP(empresa.cep),
        };
        if (empresa.id === "") {
          delete dados.id;
          response = await securedAxios.post("/empresas", dados);
        } else {
          response = await securedAxios.put(`/empresas/${empresa.id}`, dados);
        }

        return Promise.resolve(response.data);
      } catch (err) {
        return Promise.reject(err);
      }
    },
    async deletar({ commit }, id) {
      try {
        await securedAxios.delete(`/empresas/${id}`);
        commit("remover", id);
        return Promise.resolve(true);
      } catch (e) {
        return Promise.reject(e);
      }
    },
  },
};
